module.exports = __webpack_public_path__ + "static/media/objc.86118484.png";